import { __assign, __spreadArrays } from "tslib";
import { v4 as uuid } from 'uuid';
import { ViewerEventType, ViewerSetupEventType, } from '../common/viewer-events';
import { SDKEventType } from '../common/events';
import { EditorSetupEventType, EditorEventType, } from '../common/editor-events';
var LOGGER_PREFIX = 'editor-SDK: ';
var noop = function () { };
var EditorSdk = /** @class */ (function () {
    function EditorSdk(_a) {
        var shouldLog = _a.shouldLog, origin = _a.origin, _b = _a.onReady, onReady = _b === void 0 ? noop : _b;
        this.onReady = noop;
        this.pendingRequests = new Map();
        if (origin === false) {
            console.warn(LOGGER_PREFIX, 'dengariously set init sdk in non-secure mode');
        }
        this.origin = origin || '*';
        this.logger = function () {
            var args = [];
            for (var _i = 0; _i < arguments.length; _i++) {
                args[_i] = arguments[_i];
            }
            if (shouldLog) {
                console.log.apply(console, __spreadArrays([LOGGER_PREFIX], args));
            }
        };
        this.logger('new sdk instance');
        this.onReady = onReady;
        this.setupPortListeners();
    }
    EditorSdk.prototype.setupPortListeners = function () {
        var _this = this;
        var channel = new MessageChannel();
        this.viewerPort = channel.port1;
        this.sdkPort = channel.port2;
        this.sdkPort.addEventListener('message', function (e) {
            var _a;
            if (e.data.scope !== SDKEventType.sdk) {
                return;
            }
            _this.logger('got a message from from viewer: ', (_a = e.data) === null || _a === void 0 ? void 0 : _a.type, e.data);
            switch (e.data.type) {
                case ViewerEventType.ready:
                    _this.onReady();
                    break;
                case ViewerEventType.success:
                    _this.logger('completed operation', e.data.id);
                    _this.handleOppSuccess(e.data.id, e.data.payload);
                    break;
                case ViewerEventType.error:
                    _this.logger('completed operation', e.data.id);
                    _this.handleOppError(e.data.id, e.data.payload);
                    break;
                default:
                    _this.logger('no handler for this message', e.data);
                    throw new Error('event type not supported');
            }
        });
        this.logger('registered to viewer events');
        // start receiving messages
        this.sdkPort.start();
    };
    EditorSdk.prototype.handleOppSuccess = function (id, payload) {
        var _a;
        if (id === void 0) { id = ''; }
        if (this.pendingRequests.has(id)) {
            (_a = this.pendingRequests.get(id)) === null || _a === void 0 ? void 0 : _a.resolve(payload); // eslint-disable-line no-unused-expressions
            this.pendingRequests.delete(id);
        }
        else {
            this.logger('received event for non existant id');
        }
    };
    EditorSdk.prototype.handleOppError = function (id, payload) {
        var _a;
        if (id === void 0) { id = ''; }
        (_a = this.pendingRequests.get(id)) === null || _a === void 0 ? void 0 : _a.reject(payload); // eslint-disable-line no-unused-expressions
        this.pendingRequests.delete(id);
    };
    EditorSdk.prototype.onIFrameRef = function (iframe) {
        var _this = this;
        if (iframe.current) {
            iframe.current.addEventListener('load', function () {
                _this.logger('iframe loaded');
            });
        }
        window.addEventListener('message', function (e) {
            if (e.data.scope !== SDKEventType.setup) {
                return;
            }
            _this.logger('got this event on window', e.data);
            if (e.data.type === ViewerSetupEventType.readyForPort) {
                _this.logger('got port request');
                // listen to message port
                _this.setupPortListeners();
                // send message port to viewer
                _this.sendSetupMessage(iframe);
                _this.logger('sent port');
            }
        });
    };
    EditorSdk.prototype.sendSetupMessage = function (iframe) {
        var _a, _b;
        var message = {
            scope: SDKEventType.setup,
            type: EditorSetupEventType.sendMessagePort,
        };
        // eslint-disable-next-line no-unused-expressions
        (_b = (_a = iframe.current) === null || _a === void 0 ? void 0 : _a.contentWindow) === null || _b === void 0 ? void 0 : _b.postMessage(message, this.origin, [
            this.viewerPort,
        ]);
    };
    EditorSdk.prototype.sendMessage = function (event) {
        var _this = this;
        var id = uuid();
        var editorEventData = __assign(__assign({}, event), { id: id });
        this.sdkPort.postMessage(editorEventData);
        this.logger('sent message', event);
        return new Promise(function (resolve, reject) {
            return _this.pendingRequests.set(id, { resolve: resolve, reject: reject });
        });
    };
    EditorSdk.prototype.updatePageStructure = function (page) {
        var event = {
            scope: SDKEventType.sdk,
            type: EditorEventType.updatePageStructure,
            payload: page,
        };
        return this.sendMessage(event);
    };
    EditorSdk.prototype.updateBranding = function (branding) {
        var event = {
            scope: SDKEventType.sdk,
            type: EditorEventType.updateBranding,
            payload: branding,
        };
        return this.sendMessage(event);
    };
    EditorSdk.prototype.updateComponent = function (componentEvent) {
        var event = {
            scope: SDKEventType.sdk,
            type: EditorEventType.updateComponent,
            payload: componentEvent,
        };
        return this.sendMessage(event);
    };
    EditorSdk.prototype.getCompiledTemplate = function (payload) {
        var event = {
            scope: SDKEventType.sdk,
            type: EditorEventType.getCompiledTemplate,
            payload: payload,
        };
        return this.sendMessage(event);
    };
    EditorSdk.prototype.navigate = function (navigationEvent) {
        var event = {
            scope: SDKEventType.sdk,
            type: EditorEventType.navigateToPage,
            payload: navigationEvent,
        };
        return this.sendMessage(event);
    };
    EditorSdk.prototype.updateCustomFields = function (resolvedCustomFields) {
        var event = {
            scope: SDKEventType.sdk,
            type: EditorEventType.updateCustomFields,
            payload: resolvedCustomFields,
        };
        return this.sendMessage(event);
    };
    return EditorSdk;
}());
export { EditorSdk };
//# sourceMappingURL=editor-sdk.js.map